var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-find-global-partner"},[_c('div',{staticClass:"container-find-global-partner"},[_c(_vm.currentComponent,_vm._b({tag:"component",on:{"on-change-component":_vm.onChangeComponent}},'component',{..._vm.$props,..._vm.componentProps, form: _vm.formGlobalPartnerChoose},false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }